import * as Yup from "yup"
import { transformSnakeToCamel } from "utils/transform"

import { ERROR_MESSAGES } from "constants/validation"

/**
 * Number of Clicks Schema
 * Represents click tracking data for affiliate links
 * Base schema is loose to allow loading legacy data.
 */
export const NoOfClicksSchema = Yup.object()
  .transform(transformSnakeToCamel)
  .shape({
    clickId: Yup.number().nullable(),
    utmId: Yup.number().nullable(),
    clickDatetime: Yup.date().nullable(),
    noClicks: Yup.number().nullable(),
    uniqueClicks: Yup.number().nullable(),
  })

/**
 * Number of Clicks Validation Schema
 * Strict rules applied only during form submission.
 */
export const NoOfClicksValidationSchema = NoOfClicksSchema.clone().shape({
  clickId: Yup.number().required(ERROR_MESSAGES.REQUIRED),
})
